export type Entry = {
	id: number
	title: string
	path: string
	url: string
	language: string
	channel: string
	key: string
	order: number
}

export type Project = Entry & {
	intro_image: Image
	description: string
	archived: boolean
	email: string
	website: string
}

export type Event = Entry & {
	intro_image: Image
	description: string
	archived: boolean
	start_date: string
	end_date: string
	venue: string
	address: string
	postal: string
	city: string
	country: [string]
}

export type Country = Entry & {
	code: string
	latitude: string
	longitude: string
}

export const MemberType = {
	national: 'National',
	sector: 'Sectoral',
	network: 'SME-network'
}

export type Member = Entry & {
	type?: [keyof typeof MemberType]
	sector?: [string]
	organization_name: string
	image: Image
	address: string
	postal: string
	city: string
	country?: [string]
	description: string
	contact_name: string
	email: string
	phone: string
	website: string
}

export type Image = {
	empty: boolean
	width: number
	height: number
	src: string
	focus?: null
	meta?: null
	alt?: string
}

export const PublicationLabel = {
	paper: 'Position paper',
	other: 'Other publication'
}

export const ArticleLabel = {
	press: 'Press release',
	news: 'News'
}
